module.exports = __webpack_public_path__ + "img/feature_4.e6e9cb76.png";